var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99 20C4.468 19.994-.004 15.515 0 9.993.004 4.472 4.482-.002 10.003 0 15.525.002 20 4.478 20 10c-.003 5.525-4.485 10.002-10.01 10ZM2 10.172A8 8 0 1 0 2 10v.172ZM11 15H9v-2h2v2Zm0-4H9V5h2v6Z",
    fill: "#AD3F4C"
  })));
};
export default SvgInfo;